import { Resolver, Query, FieldResolver, Root, Args, Arg, Ctx, Directive } from 'type-graphql'
import { Domain, getQueryBuilderFromListParams, getRepository, ListParam } from '@things-factory/shell'
import { User } from '@things-factory/auth-base'
import { PagePreference } from './page-preference'
import { PagePreferenceList } from './page-preference-type'

@Resolver(PagePreference)
export class PagePreferenceQuery {
  @Query(returns => PagePreference!, { nullable: true, description: 'To fetch a PagePreference' })
  async pagePreference(@Arg('id') id: string, @Ctx() context: ResolverContext): Promise<PagePreference> {
    const { domain } = context.state

    return await getRepository(PagePreference).findOne({
      where: { domain: { id: domain.id }, id }
    })
  }

  @Query(returns => PagePreference, { nullable: true, description: `To fetch a User's own PagePreference` })
  async myPagePreference(
    @Arg('page') page: string,
    @Arg('element') element: string,
    @Ctx() context: any
  ): Promise<PagePreference> {
    const { domain, user } = context.state

    return await getRepository(PagePreference).findOne({
      where: { domain: { id: domain.id }, user: { id: user.id }, page, element }
    })
  }

  @Query(returns => [PagePreference], { nullable: true, description: `To fetch a User's own PagePreference` })
  async myPageAllPreferences(@Arg('page') page: string, @Ctx() context: any): Promise<PagePreference[]> {
    const { domain, user } = context.state

    return await getRepository(PagePreference).find({
      where: { domain: { id: domain.id }, user: { id: user.id }, page }
    })
  }

  @Query(returns => PagePreferenceList, { description: 'To fetch multiple PagePreferences' })
  async myPagePreferences(
    @Args(type => ListParam) params: ListParam,
    @Ctx() context: ResolverContext
  ): Promise<PagePreferenceList> {
    const { domain, user } = context.state

    const queryBuilder = getQueryBuilderFromListParams({
      domain,
      params,
      repository: await getRepository(PagePreference),
      searchables: ['page']
    }).andWhere({ user: { id: user.id } })

    const [items, total] = await queryBuilder.getManyAndCount()

    return { items, total }
  }

  @FieldResolver(type => Domain)
  async domain(@Root() pagePreference: PagePreference): Promise<Domain> {
    return pagePreference.domainId && (await getRepository(Domain).findOneBy({ id: pagePreference.domainId }))
  }

  @FieldResolver(type => User)
  async updater(@Root() pagePreference: PagePreference): Promise<User> {
    return pagePreference.updaterId && (await getRepository(User).findOneBy({ id: pagePreference.updaterId }))
  }

  @FieldResolver(type => User)
  async creator(@Root() pagePreference: PagePreference): Promise<User> {
    return pagePreference.creatorId && (await getRepository(User).findOneBy({ id: pagePreference.creatorId }))
  }
}
